// Modules
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class IconWrapperModule {
}
IconWrapperModule.ɵfac = function IconWrapperModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconWrapperModule)(); };
IconWrapperModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IconWrapperModule });
IconWrapperModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [IconModule] });
